module.exports = __webpack_public_path__ + "media/images/main_nav_language-b3bb9670a61a7385d8a4b39d6b91c22d.png";